module.exports = __webpack_public_path__ + "media/images/logo/logo_mini_color_1x-3ae69bcd5a5f549822f4846e00a667f3.png";